/**
 * SVG path data for the logo mark icon.
 */
export const logoMark = {
    paths: [],
    viewBox: '0 0 32 32',
    fill: 'none',
    svg: `<g transform="matrix(.86229 0 0 .86229 .81594 2.2034)" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2.4737"><g fill="currentColor"><line x1="20.959" x2="24.924" y1="18.579" y2="25.446" /><line x1="20.959" x2="24.924" y1="13.422" y2="6.555" /><line x1="16.494" x2="8.563" y1="16" y2="16" /></g><g fill="none"><circle cx="19.47" cy="16" r="2.976" /><circle cx="5.587" cy="16" r="2.977" /><circle cx="26.412" cy="28.023" r="2.976" /><circle cx="26.412" cy="3.977" r="2.976" /></g></g>`,
};
//# sourceMappingURL=logo-mark.js.map